import React from 'react'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import DetailsBox from '../../../../components/Cards/DetailsBox'

const HxModule = ({ pmhx, hx }) => (
  <>
    <DetailsBox
      title="History"
      rows={[
        {
          label: 'Presenting Complaint',
          value: hx?.presentingComplaint?.join(', '),
          fullWidth: true,
        },
        {
          label: 'History of Presenting Complaint',
          value: hx?.historyPresentingComplaint,
          fullWidth: true,
        },
      ]}
    />
    <DetailsBox
      title="Past Medical History"
      rows={[
        {
          label: 'Medical Conditions',
          value: pmhx.diseases.map((d) => d.disease).join(', '),
          fullWidth: true,
        },
        {
          label: 'Allergies',
          value: pmhx.allergies.join(', '),
          fullWidth: true,
        },
        {
          label: 'Medicines',
          value: pmhx.medicines.join(', '),
          fullWidth: true,
        },
        {
          label: 'Social History',
          value: pmhx.socialHx,
          fullWidth: true,
        },
        {
          label: 'Family History',
          value: pmhx.familyHx,
          fullWith: true,
        },
      ]}
    />
  </>
)

export default HxModule
